import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Auth } from '../components/Auth';
import { supabase } from '../lib/supabase';

export const LoginPage: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const message = (location.state as { message?: string })?.message;

  // Jeśli użytkownik już zalogowany – przekieruj do aplikacji
  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      if (session?.user) {
        navigate('/', { replace: true });
      }
    });
  }, [navigate]);

  return (
    <div className="min-h-viewport" style={{ minHeight: '100vh' }}>
      <div>
        {message && (
          <div
            style={{
              maxWidth: '400px',
              margin: '0 auto 20px',
              padding: '12px',
              backgroundColor: '#e8f5e9',
              color: '#2e7d32',
              borderRadius: '5px',
              fontSize: '14px',
              textAlign: 'center',
            }}
          >
            {message}
          </div>
        )}
        <Auth onAuthSuccess={() => navigate('/', { replace: true })} defaultMode="login" />
      </div>
    </div>
  );
};
